
import { defineComponent } from "vue";
import Heading4 from "@/components/headings/Heading4.vue";

export default defineComponent({
  name: "FetchingError",
  components: {
    Heading4,
  },

});
